function checkWebPSupport() {
  const elem = document.createElement('canvas');
  elem.id = 'webp-support';
  return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
}

const isWebPSupported = checkWebPSupport();

export default isWebPSupported;
